import { FilterGenerator } from './filter-generator.model'

const arrayFlattener = (previous: Array<string>, current: Array<string>) => [...previous, ...current]

export function generateFilters<M extends object>(model: M, generators: Array<FilterGenerator<M, unknown>>): Array<string> {
  const filters = generators.map(generator => generator.generate(model)).reduce(arrayFlattener, [])
  return Array.from(new Set<string>(filters))
}
